import AbsModule from '../common/AbsModule';
import {games} from './ServiceListCountry';

export default class ServiceList extends AbsModule {
    
    makeMarkup() {
        const md = this.moduleData;
        let addbottom = '';
        // if (navigator.userAgent.indexOf('iPhone OS 15')>0) {
        //     addbottom = ` style="padding-bottom: 100px;"`;
        // }
        
        // 좌측드로어에서 고객지원 제거
        return `
        <div class="ncc-ncservice"${addbottom}>
            <ul class="ncc-ncservice-list">
            
                ${!md.isServiceShow? '': `
                <li class="ncc-ncservice-item ncc-ncservice-item-plaync">
                    ${md.services.Plaync.isShow?`
                    <a href="${md.services.Plaync.url}" class="plaync"><span>${this.com.l10nData.Service["Plaync"]}</span></a>
                    `:``}
                    ${md.services.NShop.isShow?`
                    <a href="${md.services.NShop.url}" class="nshop"><span>${this.com.l10nData.Service["NShop"]}</span></a>
                    `:``}
                </li>
                `}
                
                ${!md.isGamesShow? '': `
                <li class="ncc-ncservice-item ncc-ncservice-item-games">
                    <div class="ncc-ncservice-item-games-title">${this.com.l10nData.Service.Games}</div>
                    <ul>
                    ${games(this.com.rcDash, this.com.country).map( (item, idx) => {
                        return `
                        <li class="">
                            <a href="${item.url}">
                                <span class="ncc-ncservice-item-games__name">${this.com.l10nData.Service[item.key]}</span>
                                <span class="ncc-ncservice-item-games__icon">
                                ${item.app.indexOf('pc')<0?``:`
                                    <span class="icon-official">Official Website</span>
                                `}
                                ${item.app.indexOf('apple')<0?``:`
                                    <span class="icon-apple">Apple Itunes</span>
                                `}
                                ${item.app.indexOf('android')<0?``:`
                                    <span class="icon-google">Google Play</span>
                                `}
                                </span>
                            </a>
                        </li>`;
                    }).join('\n ')}
                    </ul>
                </li>
                `}

            </ul>
        </div>
        `;
    }
}